(function () {
  var bar = document.getElementById('sticky-atc-bar');
  var btn = document.getElementById('sticky-atc-bar__button');
  if (!bar || !btn) return;

  function toggleBar() {
    if (window.scrollY > 350) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }
  }
  window.addEventListener('scroll', toggleBar, { passive: true });
  toggleBar();

  // Keep the sticky bar pointed at whichever variant is currently selected
  // on the product form, instead of always adding whichever variant was
  // selected when the page first loaded. Before this fix, changing size
  // after scrolling down would silently add the wrong size to the cart.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (!variant) return;
      btn.setAttribute('data-variant-id', variant.id);
      if (variant.available) {
        btn.removeAttribute('disabled');
        btn.textContent = 'Add to cart';
      } else {
        btn.setAttribute('disabled', 'disabled');
        btn.textContent = 'Sold out';
      }
    });
  }

  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    var variantId = btn.getAttribute('data-variant-id');
    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    var cartDrawer = document.querySelector('cart-drawer');
    var body = { id: variantId, quantity: 1 };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status) {
          // Shopify returned an error (e.g. out of stock) instead of a line item.
          btn.textContent = originalText;
          btn.disabled = false;
          window.alert(response.description || 'This item could not be added to your cart.');
          return;
        }
        btn.textContent = 'Added!';
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          // Refreshes the cart drawer contents + header cart bubble and opens
          // the drawer, matching what the desktop Add to Cart button does.
          // Previously this added the item with no visible confirmation.
          cartDrawer.renderContents(response);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  });
})();
